import React from "react";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CommonNoDataFound from "components/CommonNoDataFound/CommonNoDataFound";
import SearchBar from "components/commonSearch/SearchBar";
import Loader from "components/loader/Loader";
import star from "assets/images/smStar.svg";
import image from "assets/images/ProfileVendor.svg";


function AllotDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const {
    allotData,
    openDialog,
    title,
    titleType,
    placeholder,
    subtitle,
    type,
    onSearch,
  } = props;

  const handleClose = () => {
    props?.handleClose();
  };

  const onSubmit = (data) => {
    props?.submittAssign(data);
  };

  const handleOnError = (e) => {
    e.target.src = image;
  };
const typeName = (type, data) => {
  if(type === "Sub-Vendor"){
    return data?.companyName
  }
  else if(data?.driverName){
    return data?.driverName
  }
  else {
    return data?.name
  }
}
  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        fullWidth
        maxWidth={"md"}
        className="dialogStyle"
      >
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid md={12} className="width100">
            <DialogTitle
              id="responsive-dialog-title"
              className="allotDialogHeader"
            >  
              <Grid>
                {/* ---Close Button--- */}
                <IconButton
                  aria-label="close"
                  onClick={handleClose}
                  className="iconBtnStyle"
                >
                  <CloseIcon />
                </IconButton>
              </Grid>        
              {/* ---Heading--- */}
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                className="marginTop25 settingDialogMain pl25"
              >
                <Grid item>
                  <Typography className="font28 fontMedium colorBlue">
                    {title} <span className="colorYellow">{titleType}</span>
                  </Typography>
                  {type !== "vechileView" && subtitle ? (
                    <Typography className="font10 fontMedium colorGrey marginBlock10">
                      {subtitle}
                    </Typography>
                  ) : null}
                </Grid>
              </Grid>
            </DialogTitle>
            {/* ---Body--- */}
            <DialogContent className="ptb0Rl30">
              <SearchBar placeholder={placeholder} onSearch={onSearch} />
              {type === "vehicleView" ? (
                <Typography className="font10 fontMedium colorBlue marginTopBottom20">
                  Suggested Drivers
                </Typography>
              ) : null}

              <DialogContentText className="allotBody">
                {props?.loader ? (
                  <Loader />
                ) : allotData?.length > 0 ? (
                  allotData?.map((ele, idx) => (
                    <Grid
                      container
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      className="marginBlock10 colorBlack ptb20"
                      key={ele.id}
                    >
                      <Grid
                        item
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        md={6}
                      >
                        <Grid item md={3} className="displayInlineGrid">
                          <div className="displayInlineGrid">
                            {ele?.avtar &&
                            ele?.avtar !== null &&
                            ele?.avtar?.url ? (
                              <img
                                src={ele?.avtar?.url}
                                alt="profile"
                                className="imgSize60"
                                onError={handleOnError}
                              />
                            ) : (
                              <img
                                src={image}
                                alt="profile"
                                className="imgSize60"
                              />
                            )}

                            {ele?.rating &&
                              ele?.rating !== null &&
                              ele?.rating !== 0 &&
                              ele?.rating !== undefined && (
                                <div className="textCenter marginTop5">
                                  <img
                                    src={star}
                                    alt="star"
                                    className="width16 marginRight6"
                                  />

                                  <span className="font16">{ele?.rating}</span>
                                </div>
                              )}
                          </div>
                        </Grid>
                        <Grid
                          item
                          md={8}
                          alignSelf={"center"}
                          className="marginInline10"
                        >
                          <Typography className="font18 fontSemi">
                          {typeName(titleType,ele)}
                          </Typography>

                          {type && type === "subvendorView" ? (
                            <Typography className="font14 fontNormal colorGrey">
                              {ele?.city}
                            </Typography>
                          ) : type !== "vechileView" ? (
                            <Typography className="font14 fontNormal colorGrey">
                              {ele?.mobile}
                            </Typography>
                          ) : null}
                        </Grid>
                      </Grid>
                      <Grid item md={3} alignSelf={"center"}>
                        {ele?.Vehicle?.regNumber && (
                          <Typography className="font20 fontMedium">
                            {ele?.Vehicle?.regNumber}
                          </Typography>
                        )}
                        {ele?.Vehicle?.carModel && (
                          <Typography className="font16 fontNormal">
                            {ele?.Vehicle?.carModel}
                          </Typography>
                        )}
                        {type !== "tripView" && (
                          <Typography className="font16 fontNormal">
                            {ele?.mobile}
                          </Typography>
                        )}
                      </Grid>
                      <Grid item md={2} alignSelf={"center"}>
                        <button
                          className="assignBtn cursor"
                          onClick={() => 
                            onSubmit(ele)}
                        >
                          {"Assign"}
                        </button>
                      </Grid>
                    </Grid>
                  ))
                ) : (
                  <Grid item>
                    <CommonNoDataFound />
                  </Grid>
                )}
              </DialogContentText>
            </DialogContent>
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
}

export default AllotDialog;
